// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"style_dashboard__3KP4c","body":"style_body__2gGdI","body__content":"style_body__content__2Jl2J"};